import { APIResponse } from './proxy/BaseProxy';
import { DEFAULT_FAIL_RESPONSE } from './proxy/constants';
import FetchProxy from './proxy/FetchProxy';
import XHRProxy from './proxy/XHRProxy';
import { isBrowser } from '~/helpers/tools';

/**
 * 处理 HTTP Request 请求， 该类会调用 xhr 或者是 fetch 来发送 http 请求，同时根据当前的环境进行判断是否 xhr 还是 使用 fetch
 * ， 可以向下兼容更低的浏览器版本, 同时支持了请求拦截器， 可以在通用的请求中设置拦截器
 */
export class HttpRequest {
  public static responseInterceptor: (res: APIResponse) => void;

  public async send<D extends { [key: string]: any }>(config: ApiTypes.HttpRequestConfig): Promise<ApiBaseResult<D>> {
    let api;
    if (!isBrowser) {
      api = new FetchProxy(config);
    } else {
      if (config.useFetch) {
        if (typeof window !== 'undefined' && typeof fetch !== 'undefined') {
          api = new FetchProxy(config);
        } else {
          console.warn('当前环境不支持 fetch api， 切换为 XHR 对象');
          api = new XHRProxy(config);
        }
      } else {
        if (
          typeof XMLHttpRequest === 'undefined'
          && typeof fetch !== 'undefined'
        ) {
          console.warn('当前环境不支持 XMLHttpRequest api, 支持 fetch api， 则使用 fetch');
          api = new FetchProxy(config);
        } else {
          api = new XHRProxy(config);
        }
      }
    }
    // 校验 config
    if (!api.validateConfig()) {
      return Promise.resolve(DEFAULT_FAIL_RESPONSE);
    }
    // 发送请求
    const response = await api.send();
    // 统一处理拦截器
    if (HttpRequest.responseInterceptor && isBrowser) {
      HttpRequest.responseInterceptor(response);
    }
    return response.data;
  }
}

// 向外暴露 request 单例
export const request: HttpRequest = new HttpRequest();
